const Marquee = ({ items }) => (
  <div className="marquee-hover overflow-hidden bg-[#07182E] border-y border-white/5 py-5" aria-hidden="true">
    <div className="animate-marquee-slow flex w-max items-center">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-heading text-xl md:text-2xl font-extrabold tracking-tight text-white/90 px-6">{item}</span>
          <span className="h-2 w-2 rotate-45 bg-[#17B8A6] shrink-0" />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
